(() => {
  const initContactContext = (root = document) => {
    const form = root.querySelector('#DcwContactForm');
    if (!form || form.dataset.dcwContextReady === 'true') return;

    const topic = new URLSearchParams(window.location.search).get('temat');
    const select = form.querySelector('[data-dcw-contact-topic]');
    const source = form.querySelector('[data-dcw-contact-source]');
    const message = form.querySelector('textarea[name="contact[body]"]');

    if (topic === 'odziez-odblaskowa') {
      if (select) select.value = 'Odzież odblaskowa i robocza';
      if (source) source.value = 'Strona: Odzież odblaskowa';
      if (message && !message.value.trim()) {
        message.placeholder = 'Np. 25 koszulek odblaskowych, rozmiary S–XXL, logo z przodu i z tyłu, potrzebne do końca miesiąca';
      }
    }

    form.dataset.dcwContextReady = 'true';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initContactContext(), { once: true });
  } else {
    initContactContext();
  }

  document.addEventListener('shopify:section:load', (event) => initContactContext(event.target));
})();
